import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import useHttp from "../../hooks/useHttp";
import Interval from "../../models/communications/Interval";
import LinearProgress from "@mui/material/LinearProgress";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import IconButton from "@mui/material/IconButton";
import { useStoreDispatch, useStoreSelector } from "../../store/Hooks";
import { interactionTreeSliceActions } from "../../store/slices/InteractionTreeSlice";
import { navSliceActions } from "../../store/slices/NavSlice";
import { useEffect } from "react";
import InteractionNodeInterval from "../../models/interactions/InteractionNodeInterval";
import EditorWrapper from "../ui/EditorWrapper";

const testing = process.env.REACT_APP_TEST_MODE === "test";

let intervalsEditorIsInitial = true;

interface InteractionNodeIntervalsEditorProps {
  interaction_node_interval: InteractionNodeInterval;
  inDrawer?: boolean;
}

const InteractionNodeIntervalsEditor = (
  props: InteractionNodeIntervalsEditorProps,
) => {
  // console.log(props)
  const dispatch = useStoreDispatch();
  const { isLoading, sendRequest: fetchData } = useHttp();

  const intervals = useStoreSelector(
    (state) => state.interactionTree.Intervals,
  );

  // store unsaved/unmofidied interval in case we need to revert redux changes.

  // updating intervals must save to redux state, since interactions are handled there
  const handleCommunicationSetMapping = (value: any) => {
    dispatch(
      interactionTreeSliceActions.updateInterval({
        id: props.interaction_node_interval.id,
        communication_set_id: value,
      }),
    );
  };

  useEffect(() => {
    // set local state to controls' value
    if (intervalsEditorIsInitial) {
      intervalsEditorIsInitial = false;
      return;
    }
  }, []);

  // updating interactions must save to redux state, since interactions are handled there
  const save = async () => {
    const objIndex = intervals.findIndex(
      (obj) => obj.id === props.interaction_node_interval.id,
    );
    const thisInterval: Interval = intervals[objIndex];

    const data = thisInterval;
    const url: string =
      process.env.REACT_APP_API_URL +
      "/interval?id=eq." +
      props.interaction_node_interval.id;
    const requestSettings = {
      url: url,
      method: "PUT",
      body: data,
      headers: {
        Authorization: "Bearer " + process.env.REACT_APP_POSTGREST_JWT,
        "Content-Type": "application/json",
        "Content-Profile": testing ? "test" : "build"
      },
    };
    fetchData(requestSettings);
  };

  const handleCloseWithoutSaving = async () => {
    // the next time this loads up, it should know its the first time of that instance
    intervalsEditorIsInitial = true;
  };

  const handleOpenCommunicationsDrawer = () => {
    // open communications
    dispatch(
      navSliceActions.openRightDrawer({
        content: props.interaction_node_interval.communication_set_id,
        type: "communications",
      }),
    );

    // the next time this loads up, it should know its the first time of that instance
    intervalsEditorIsInitial = true;
  };

  return (
    <EditorWrapper
      save={save}
      cancel={handleCloseWithoutSaving}
      table={
        "Interaction Node " +
        props.interaction_node_interval.interaction_node_id
      }
      title={"Interval " + props.interaction_node_interval.interval_id}
      inDrawer={props.inDrawer}
    >
      <Box data-testid="interactionNodeIntervalEditorTest">
        <Grid container style={{}}>
          <Grid item xs={12} style={{}}>
            <div>
              <div style={{ padding: "10px" }}>
                <TextField
                  sx={{ width: "85%" }}
                  id="outlined-required"
                  label="Communication Set"
                  defaultValue={
                    props.interaction_node_interval.communication_set_id
                  }
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleCommunicationSetMapping(event.target.value);
                  }}
                />
                <IconButton
                  onClick={handleOpenCommunicationsDrawer}
                  style={{ float: "right" }}
                >
                  {" "}
                  <EventAvailableIcon
                    color="primary"
                    sx={{ fontSize: "40pt" }}
                  />
                </IconButton>
              </div>
            </div>{" "}
            {isLoading && <LinearProgress />}
            <div style={{ float: "left", padding: "15px" }}>
              <Button
                onClick={handleCloseWithoutSaving}
                color="warning"
                variant="contained"
              >
                <ArrowBackIcon />
                Exit Without Saving
              </Button>
            </div>
            <div style={{ float: "left", padding: "15px" }}>
              <Button color="error" variant="contained">
                <DeleteForeverIcon />
                Delete
              </Button>
            </div>
            <div style={{ float: "right", padding: "15px" }}>
              <Button onClick={save} variant="contained">
                <SaveIcon />
                Save
              </Button>
            </div>
          </Grid>
        </Grid>
      </Box>
    </EditorWrapper>
  );
};

export default InteractionNodeIntervalsEditor;
